import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { Navigation, NavItems } from '../../navigation/Navigation';
import { CreditDocuments } from '@interhyp/module-documents';

export interface ExistingDataInquiryDocumentsWrapperProps {
  providerId: string;
}

export function ExistingDataInquiryDocumentsWrapper({
  providerId,
}: ExistingDataInquiryDocumentsWrapperProps): JSX.Element {
  const { existingDataInquiryId } = useParams<{ existingDataInquiryId: string }>();
  const navigationItems: NavItems = useMemo(() => {
    return [
      {
        to: `/credit/existing-data-inquiries/${existingDataInquiryId}`,
        translation: 'navigation.existingDataInquiry',
      },
      {
        to: `/credit/existing-data-inquiries/${existingDataInquiryId}/documents`,
        translation: 'navigation.documents',
      },
    ];
  }, [existingDataInquiryId]);

  return (
    <>
      <Navigation navItems={navigationItems} />
      <CreditDocuments existingDataInquiryId={existingDataInquiryId} providerId={providerId} />
    </>
  );
}
